function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.32 0h7.36C22.41 0 24 1.6 24 8.32v7.36c0 6.73-1.6 8.32-8.32 8.32H8.32C1.59 24 0 22.4 0 15.68V8.32C0 1.59 1.6 0 8.32 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.65 8.27c.12-.38 0-.65-.53-.65h-1.74c-.44 0-.65.24-.76.5 0 0-.9 2.16-2.16 3.57-.4.4-.59.54-.8.54-.13 0-.28-.14-.28-.51V8.25c0-.44-.14-.65-.5-.65h-2.75c-.27 0-.44.2-.44.41 0 .42.62.53.7 1.71v2.58c0 .55-.1.66-.33.66-.6 0-2.03-2.19-2.9-4.68C7 7.8 6.83 7.6 6.4 7.6H4.62c-.5 0-.59.24-.59.5 0 .45.6 2.76 2.76 5.8 1.44 2.09 3.5 3.2 5.34 3.2 1.11 0 1.25-.25 1.25-.67v-1.58c0-.5.1-.59.46-.59.25 0 .7.14 1.74 1.14 1.19 1.18 1.4 1.72 2.05 1.72h1.75c.5 0 .74-.25.6-.74-.15-.5-.72-1.2-1.47-2.05-.4-.48-1.01-1-1.2-1.25-.25-.34-.19-.48 0-.78-.02 0 2.12-3.02 2.34-4.03z",
  fill: "#4680C2"
})));